import store from '../store'

const errorNotification = (error) => {
    let message = 'No response from server was received'
    if ('response' in error) {
        if (error.response.status === 400) {
            message = `Validation error, please, check if everything is correct`
        } else {
            message = `Error during server request (Code ${error.response.status})`
        }
    } else if ('message' in error) {
        message = error.message
    }
    store.dispatch('snackbar/error', message)
}

const getResponseError = (response) => {
    if ('message' in response) {
        if ('response' in response && 'data' in response.response && 'detail' in response.response.data) {
            return new Error(response.response.data.detail)
        } else {
            return new Error(response.message)
        }
    } else {
        return new Error('Unidentified error occurred during request')
    }
}

export {
    errorNotification,
    getResponseError
}


// Replace catches with
// .catch((error) => {
// errorNotification(error)
// })